import { AsyncGridColumns } from '~/shared/ui/AsyncGrid'
import { Gallery } from '~/shared/ui/Gallery'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.car detail',
    field: 'carDetail',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.damage extent',
    field: 'carDamageExtend',
    flex: 1,
    sortable: false,
  },
  {
    headerName: 'column.damage cost',
    field: 'cost',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => value && value.toLocaleString(),
  },
  {
    headerName: 'column.photos',
    field: 'photos',
    flex: 1,
    sortable: false,
    renderCell: ({ value }) => (
      <Gallery
        buttonTitle='button.open'
        buttonProps={{
          variant: 'textBrand',
          size: 'sm',
        }}
        showList={false}
        images={value}
      />
    ),
  },
  {
    headerName: 'column.driver full name',
    field: 'driverFullName',
    flex: 1,
    sortable: false,
  },
]
